import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";

import { BASE_URL } from "../../utils/serverContextPath";
import { isUserLoggedIn } from "../../pages/userapp/ServiceUserApp";


export default function ForumTopicDetail({
    topic,
    onClose
}) {

    //==========================================================
    // Hooks
    //==========================================================

    const { t } = useTranslation();

    const navigate = useNavigate();


    //==========================================================
    // Utilisateur connecté
    //==========================================================

    const connected = isUserLoggedIn();

    const [
        attachedFileUrl,
        setAttachedFileUrl
    ] = useState(null);


    const [
        attachedFileType,
        setAttachedFileType
    ] = useState(null);


    const [
        loadingAttachedFile,
        setLoadingAttachedFile
    ] = useState(false);


    const [
        attachedFileError,
        setAttachedFileError
    ] = useState(false);

const [videoThumbnail, setVideoThumbnail] = useState(null);
const [videoThumbnailLoading, setVideoThumbnailLoading] = useState(false);
const [videoThumbnailError, setVideoThumbnailError] = useState(false);

    //==========================================================
    // Chargement de attachedFile1
    //
    // IMPORTANT :
    // useEffect est également AVANT le if (!topic)
    //==========================================================

    useEffect(() => {

        let objectUrl = null;


        const loadAttachedFile = async () => {

            //--------------------------------------------------
            // Aucun topic
            //--------------------------------------------------

            if (!topic) {

                setAttachedFileUrl(null);

                setAttachedFileType(null);

                setAttachedFileError(false);

                setLoadingAttachedFile(false);

                return;
            }


            //--------------------------------------------------
            // Aucun fichier attaché
            //--------------------------------------------------

            if (!topic.attachedFile1) {

                setAttachedFileUrl(null);

                setAttachedFileType(null);

                setAttachedFileError(false);

                setLoadingAttachedFile(false);

                return;
            }


            try {

                setLoadingAttachedFile(true);

                setAttachedFileError(false);


                //------------------------------------------------
                // Endpoint du fichier attaché du Topic
                //
                // attachedFile1 = index 1
                //------------------------------------------------

                const url =
                    `${BASE_URL}forumtopic/downloadfile/${topic.id}/1`;


                console.log(
                    "ForumTopicDetail - chargement fichier :",
                    url
                );


                //------------------------------------------------
                // Récupération sous forme Blob
                //------------------------------------------------

                const response =
                    await axios.get(
                        url,
                        {
                            responseType: "blob"
                        }
                    );


                //------------------------------------------------
                // Content-Type
                //------------------------------------------------

                const contentType =
                    response.headers?.["content-type"] ||
                    response.data?.type ||
                    "";


                console.log(
                    "ForumTopicDetail - Content-Type :",
                    contentType
                );


                //------------------------------------------------
                // Création du Blob
                //------------------------------------------------

                const blob =
                    new Blob(
                        [response.data],
                        {
                            type: contentType
                        }
                    );


                //------------------------------------------------
                // Création URL temporaire
                //------------------------------------------------

                objectUrl =
                    window.URL.createObjectURL(
                        blob
                    );


                setAttachedFileUrl(
                    objectUrl
                );


                //------------------------------------------------
                // Détection du type
                //------------------------------------------------

                const mimeType =
                    contentType.toLowerCase();


                if (
                    mimeType.startsWith("image/")
                ) {

                    setAttachedFileType(
                        "image"
                    );

                }
                else if (
                    mimeType.startsWith("video/")
                ) {

                    setAttachedFileType(
                        "video"
                    );

                }
                else {

                    setAttachedFileType(
                        "other"
                    );

                }

            }
            catch (error) {

                console.error(
                    "ForumTopicDetail - erreur chargement fichier :",
                    error
                );


                setAttachedFileUrl(null);

                setAttachedFileType(null);

                setAttachedFileError(true);

            }
            finally {

                setLoadingAttachedFile(false);

            }

        };


        loadAttachedFile();


        //======================================================
        // Nettoyage de ObjectURL
        //======================================================

        return () => {

            if (objectUrl) {

                window.URL.revokeObjectURL(
                    objectUrl
                );

            }

        };

    }, [
        topic?.id,
        topic?.attachedFile1
    ]);


 useEffect(() => {

    let cancelled = false;

    const generateVideoThumbnail = async () => {

        // ----------------------------------------------------
        // Pas une vidéo
        // ----------------------------------------------------

        if (
            attachedFileType !== "video" ||
            !attachedFileUrl
        ) {
            setVideoThumbnail(null);
            return;
        }

        setVideoThumbnailLoading(true);
        setVideoThumbnailError(false);
        setVideoThumbnail(null);

        const video = document.createElement("video");

        video.preload = "metadata";
        video.muted = true;
        video.playsInline = true;

        // Important pour permettre canvas avec une URL distante
        video.crossOrigin = "anonymous";

        video.src = attachedFileUrl;

        try {

            // ------------------------------------------------
            // Attendre que les métadonnées soient disponibles
            // ------------------------------------------------

            await new Promise((resolve, reject) => {

                video.onloadedmetadata = resolve;

                video.onerror = () => {
                    reject(
                        new Error(
                            "Impossible de charger la vidéo"
                        )
                    );
                };

            });

            // ------------------------------------------------
            // Aller à la première image
            // ------------------------------------------------

            await new Promise((resolve) => {

                video.onseeked = resolve;

                // 0.1 seconde évite parfois une première frame noire
                video.currentTime = 0.1;

            });

            if (cancelled) {
                return;
            }

            // ------------------------------------------------
            // Dimensions de la miniature
            // ------------------------------------------------

            const MAX_WIDTH = 640;

            const videoWidth = video.videoWidth;
            const videoHeight = video.videoHeight;

            if (!videoWidth || !videoHeight) {
                throw new Error(
                    "Dimensions vidéo invalides"
                );
            }

            const ratio =
                Math.min(
                    1,
                    MAX_WIDTH / videoWidth
                );

            const width =
                Math.round(
                    videoWidth * ratio
                );

            const height =
                Math.round(
                    videoHeight * ratio
                );

            // ------------------------------------------------
            // Canvas
            // ------------------------------------------------

            const canvas =
                document.createElement("canvas");

            canvas.width = width;
            canvas.height = height;

            const context =
                canvas.getContext("2d");

            context.drawImage(
                video,
                0,
                0,
                width,
                height
            );

            // ------------------------------------------------
            // Compression JPEG
            // ------------------------------------------------

            const thumbnail =
                canvas.toDataURL(
                    "image/jpeg",
                    0.75
                );

            if (!cancelled) {
                setVideoThumbnail(thumbnail);
            }

        } catch (error) {

            console.error(
                "Erreur génération miniature vidéo :",
                error
            );

            if (!cancelled) {
                setVideoThumbnailError(true);
            }

        } finally {

            video.pause();
            video.removeAttribute("src");
            video.load();

            if (!cancelled) {
                setVideoThumbnailLoading(false);
            }
        }
    };

    generateVideoThumbnail();

    return () => {
        cancelled = true;
    };

}, [
    attachedFileUrl,
    attachedFileType
]);   
    //==========================================================
    // Ouvrir le fichier dans un nouvel onglet
    //==========================================================

    const openAttachedFile = () => {

        if (!attachedFileUrl) {
            return;
        }


        window.open(
            attachedFileUrl,
            "_blank",
            "noopener,noreferrer"
        );

    };


    //==========================================================
    // Affichage du fichier attaché
    //==========================================================

    const renderAttachedFile = () => {

        //------------------------------------------------------
        // Aucun fichier
        //------------------------------------------------------

        if (!topic?.attachedFile1) {
            return null;
        }


        //------------------------------------------------------
        // Chargement
        //------------------------------------------------------

        if (loadingAttachedFile) {

            return (

                <div
                    className="text-center py-4"
                >

                    <div
                        className="spinner-border text-success"
                        role="status"
                    >

                        <span
                            className="visually-hidden"
                        >
                            Chargement...
                        </span>

                    </div>


                    <div
                        className="small text-muted mt-2"
                    >

                        Chargement du fichier...

                    </div>

                </div>

            );

        }


        //------------------------------------------------------
        // Erreur
        //------------------------------------------------------

        if (attachedFileError) {

            return (

                <div
                    className="alert alert-warning mt-3"
                >

                    <i
                        className="bi bi-exclamation-triangle me-2"
                    ></i>

                    Impossible d'afficher le fichier attaché.

                </div>

            );

        }


        //------------------------------------------------------
        // URL inexistante
        //------------------------------------------------------

        if (!attachedFileUrl) {
            return null;
        }


        //======================================================
        // IMAGE
        //======================================================

        if (attachedFileType === "image") {

            return (

                <div
                    className="mt-4"
                    style={{
                        width: "100%",
                        backgroundColor: "#000",
                        borderRadius: "8px",
                        overflow: "hidden",
                        textAlign: "center"
                    }}
                >

                    <img
                        src={attachedFileUrl}
                        alt={
                            topic.topicObject ||
                            "Image attachée"
                        }
                        onClick={
                            openAttachedFile
                        }
                        style={{
                            display: "block",
                            width: "100%",
                            maxHeight: "600px",
                            objectFit: "contain",
                            cursor: "pointer",
                            backgroundColor: "#000"
                        }}
                    />

                </div>

            );

        }


        //======================================================
        // VIDEO
        //======================================================

// ========================================================
// VIDEO
// ========================================================

if (attachedFileType === "video") {

    return (
        <div
            className="forum-attached-file mt-3"
            onClick={openAttachedFile}
            style={{
                position: "relative",
                width: "100%",
                maxWidth: "650px",
                height: "365px",
                margin: "0 auto",
                borderRadius: "10px",
                overflow: "hidden",
                backgroundColor: "#111",
                cursor: "pointer",
                boxShadow:
                    "0 2px 8px rgba(0,0,0,0.15)"
            }}
        >

            {/* ==================================================
                MINIATURE VIDEO
               ================================================== */}

            {videoThumbnail && (

                <img
                    src={videoThumbnail}
                    alt="Aperçu de la vidéo"
                    style={{
                        width: "100%",
                        height: "100%",
                        display: "block",
                        objectFit: "cover"
                    }}
                />

            )}

            {/* ==================================================
                CHARGEMENT MINIATURE
               ================================================== */}

            {videoThumbnailLoading && (

                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#222"
                    }}
                >

                    <div
                        className="spinner-border text-light"
                        role="status"
                    >
                        <span className="visually-hidden">
                            Génération de l'aperçu...
                        </span>
                    </div>

                </div>

            )}

            {/* ==================================================
                ERREUR MINIATURE
               ================================================== */}

            {!videoThumbnailLoading &&
                !videoThumbnail &&
                videoThumbnailError && (

                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#222",
                        color: "#fff"
                    }}
                >

                    <i
                        className="bi bi-camera-video"
                        style={{
                            fontSize: "55px"
                        }}
                    />

                    <div className="mt-2">
                        Vidéo
                    </div>

                </div>

            )}

            {/* ==================================================
                BOUTON PLAY
               ================================================== */}

            <div
                style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background:
                        "linear-gradient(" +
                        "rgba(0,0,0,0.05)," +
                        "rgba(0,0,0,0.20)" +
                        ")",
                    pointerEvents: "none"
                }}
            >

                <div
                    style={{
                        width: "75px",
                        height: "75px",
                        borderRadius: "50%",
                        backgroundColor:
                            "rgba(220, 0, 0, 0.95)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow:
                            "0 4px 15px rgba(0,0,0,0.45)"
                    }}
                >

                    <i
                        className="bi bi-play-fill"
                        style={{
                            color: "#fff",
                            fontSize: "48px",
                            marginLeft: "5px"
                        }}
                    />

                </div>

            </div>

            {/* ==================================================
                INDICATION
               ================================================== */}

            <div
                style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: "15px",
                    color: "#fff",
                    fontSize: "14px",
                    textAlign: "center",
                    background:
                        "linear-gradient(" +
                        "transparent," +
                        "rgba(0,0,0,0.85)" +
                        ")",
                    pointerEvents: "none"
                }}
            >

                <i className="bi bi-play-circle me-2"></i>

                Cliquez pour visualiser la vidéo

            </div>

        </div>
    );
}


        //======================================================
        // AUTRE TYPE DE FICHIER
        //======================================================

        return (

            <div
                className="mt-4"
            >

                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={
                        openAttachedFile
                    }
                >

                    <i
                        className="bi bi-paperclip me-2"
                    ></i>

                    Fichier attaché

                </button>

            </div>

        );

    };


    //==========================================================
    // IMPORTANT :
    // Le return conditionnel est maintenant APRÈS les Hooks
    //==========================================================

    if (!topic) {

        return null;

    }


    //==========================================================
    // Auteur
    //==========================================================

    const author =
        topic.author || {};


    //==========================================================
    // Avatar par défaut
    //==========================================================

    const defaultAvatar =
        "https://cdn-icons-png.flaticon.com/512/847/847969.png";


    //==========================================================
    // Photo auteur
    //==========================================================

    const photo =
        author.photoUrl
            ?
            `${BASE_URL}userapp/downloadprofile/${author.id}`
            :
            defaultAvatar;


    //==========================================================
    // Format date
    //==========================================================

    const formatDateTime = (dateValue) => {

        if (!dateValue) {
            return "";
        }


        //------------------------------------------------------
        // Format Spring Boot :
        // 14/07/2026 23:00:00
        //------------------------------------------------------

        if (typeof dateValue === "string") {

            const parts =
                dateValue.split(" ");


            if (parts.length === 2) {

                const datePart =
                    parts[0].split("/");


                const timePart =
                    parts[1].split(":");


                if (
                    datePart.length === 3 &&
                    timePart.length >= 2
                ) {

                    return (
                        `${datePart[0]}/` +
                        `${datePart[1]}/` +
                        `${datePart[2]} ` +
                        `${timePart[0]}:` +
                        `${timePart[1]}:` +
                        `${timePart[2] || "00"}`
                    );

                }

            }

        }


        //------------------------------------------------------
        // ISO Date
        //------------------------------------------------------

        try {

            return new Intl.DateTimeFormat(
                "fr-FR",
                {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit"
                }
            ).format(
                new Date(dateValue)
            );

        }
        catch (error) {

            return dateValue;

        }

    };


    //==========================================================
    // RENDER
    //==========================================================

    return (

        <div
            className="modal fade show d-block"
            style={{
                background: "rgba(0,0,0,.55)"
            }}
        >

            <div
                className="modal-dialog modal-xl modal-dialog-scrollable"
            >

                <div
                    className="modal-content"
                >

                    {/*================================================
                        HEADER
                    =================================================*/}

                    <div
                        className="modal-header bg-success text-white"
                    >

                        <h4
                            className="modal-title"
                        >

                            <i
                                className="bi bi-chat-square-text-fill me-2"
                            ></i>

                            {t("forum.topicDetail")}

                        </h4>


                        <button
                            type="button"
                            className="btn-close btn-close-white"
                            onClick={onClose}
                        >
                        </button>

                    </div>


                    {/*================================================
                        BODY
                    =================================================*/}

                    <div
                        className="modal-body"
                    >

                        <div
                            className="row"
                        >

                            {/*==========================================
                                Auteur
                            ==========================================*/}

                            <div
                                className="col-lg-3"
                            >

                                <div
                                    className="card shadow-sm"
                                >

                                    <div
                                        className="card-body text-center"
                                    >

                                        <img
                                            src={photo}
                                            alt={
                                                author?.fullName ||
                                                "Auteur"
                                            }
                                            className="rounded-circle shadow"
                                            style={{
                                                width: 130,
                                                height: 130,
                                                objectFit: "cover"
                                            }}
                                            onError={(e) => {

                                                e.currentTarget.src =
                                                    defaultAvatar;

                                            }}
                                        />


                                        <h5
                                            className="mt-3"
                                        >

                                            {
                                                author?.fullName ||
                                                "-"
                                            }

                                        </h5>


                                        <div
                                            className="text-muted"
                                        >

                                            {
                                                author?.email ||
                                                ""
                                            }

                                        </div>


                                        <div
                                            className="mt-2"
                                        >

                                            {
                                                author?.phoneNumber ||
                                                ""
                                            }

                                        </div>

                                    </div>

                                </div>

                            </div>


                            {/*==========================================
                                Sujet
                            ==========================================*/}

                            <div
                                className="col-lg-9"
                            >

                                <div
                                    className="card shadow-sm"
                                >

                                    <div
                                        className="card-body"
                                    >

                                        <h2
                                            className="text-success fw-bold"
                                        >

                                            {
                                                topic.topicObject
                                            }

                                        </h2>


                                        <hr />


                                        {/*================================
                                            Informations
                                        =================================*/}

                                        <div
                                            className="mb-3"
                                        >

                                            <span
                                                className="badge bg-secondary me-2"
                                            >

                                                <i
                                                    className="bi bi-calendar-event me-1"
                                                ></i>

                                                {
                                                    formatDateTime(
                                                        topic.dateForumTopic
                                                    )
                                                }

                                            </span>


                                            {
                                                topic.pinned &&

                                                <span
                                                    className="badge bg-warning text-dark me-2"
                                                >

                                                    <i
                                                        className="bi bi-pin-angle-fill me-1"
                                                    ></i>

                                                    Epinglé

                                                </span>
                                            }


                                            {
                                                topic.resolved &&

                                                <span
                                                    className="badge bg-success"
                                                >

                                                    <i
                                                        className="bi bi-check-circle-fill me-1"
                                                    ></i>

                                                    Résolu

                                                </span>
                                            }

                                        </div>


                                        {/*================================
                                            Corps du sujet
                                        =================================*/}

                                        <div
                                            className="border rounded p-4"
                                            style={{
                                                minHeight: 250,
                                                whiteSpace: "pre-wrap",
                                                textAlign: "justify",
                                                lineHeight: "1.9"
                                            }}
                                        >

                                            {
                                                topic.topicBody
                                            }

                                        </div>


                                        {/*================================
                                            PIECE JOINTE
                                        =================================*/}

                                        {
                                            renderAttachedFile()
                                        }


                                        <hr />


                                        {/*================================
                                            Statistiques
                                        =================================*/}

                                        <div
                                            className="row text-center"
                                        >

                                            <div
                                                className="col-md-4"
                                            >

                                                <h3
                                                    className="text-primary"
                                                >

                                                    {
                                                        topic.nbViews ||
                                                        0
                                                    }

                                                </h3>


                                                <div>

                                                    <i
                                                        className="bi bi-eye me-2"
                                                    ></i>

                                                    {
                                                        t(
                                                            "forum.views"
                                                        )
                                                    }

                                                </div>

                                            </div>


                                            <div
                                                className="col-md-4"
                                            >

                                                <h3
                                                    className="text-danger"
                                                >

                                                    {
                                                        topic.nbLikes ||
                                                        0
                                                    }

                                                </h3>


                                                <div>

                                                    <i
                                                        className="bi bi-heart-fill me-2"
                                                    ></i>

                                                    {
                                                        t(
                                                            "forum.likes"
                                                        )
                                                    }

                                                </div>

                                            </div>


                                            <div
                                                className="col-md-4"
                                            >

                                                <h3
                                                    className="text-success"
                                                >

                                                    {
                                                        topic.nbMessage ||
                                                        0
                                                    }

                                                </h3>


                                                <div>

                                                    <i
                                                        className="bi bi-chat-dots-fill me-2"
                                                    ></i>

                                                    {
                                                        t(
                                                            "forum.replies"
                                                        )
                                                    }

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>


                    {/*================================================
                        FOOTER
                    =================================================*/}

                    <div
                        className="modal-footer"
                    >

                        <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={onClose}
                        >

                            <i
                                className="bi bi-x-circle me-2"
                            ></i>

                            {
                                t(
                                    "button.close"
                                )
                            }

                        </button>


                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={() =>
                                navigate(
                                    `/forum/conversation/${topic.id}`
                                )
                            }
                        >

                            <i
                                className="bi bi-chat-dots-fill me-2"
                            ></i>

                            {
                                t(
                                    "forum.openDiscussionButton"
                                )
                            }

                        </button>

                    </div>

                </div>

            </div>

        </div>

    );

}